module.exports = __webpack_public_path__ + "img/bind.c5feca32.svg";